<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template v-if="row.checkStatus==0" slot-scope="{ row, index }" slot="action">
					<Button type="warning" size="small" style="margin-right: 5px" @click="denyCheck(row.id)">拒绝</Button>
					<Button type="success" size="small" style="margin-right: 5px" @click="passCheck(row.id)">通过</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="deneyShow" title="审核拒绝" width="300">
			<Input type="textarea" v-model="denyCheckData.checkRemark" maxlength="255" placeholder="请输入拒绝原因"></Input>
			
			<div slot="footer">
				<Button type="primary" @click="denyCheckSure">确认</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryConditionSelfCompany'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				deneyShow:false,
				denyCheckData:{
					
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '审核ID',
						width: 200,
						key: 'id',
						align: 'center'
					},
					{
						title: '用户	ID',
						key: 'userId',
						align: 'center',
						width: 200,
					},
					{
						title: '用户	名',
						key: 'name',
						align: 'center',
						width: 200,
					},
					{
						title: '企业名称',
						key: 'company',
						align: 'center',
						width: 300,
					}, {
						title: '营业执照',
						key: 'licenseUrl',
						align: 'center',
						width: 600,
					}, {
						title: '提交时间',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '审核时间',
						key: 'checkTime',
						align: 'center',
						width: 200,
					}, {
						title: '是否有待审核职位',
						align: 'center',
						width: 200,
						render: (h, params) => {
							let name;
							let val = params.row.hasWaitingCheckJob;
							if (val == 1) {
								name = '是'
							} else{
								name = '否'
							}
							return h('span', name)
						}
					}, {
						title: '原因提示',
						key: 'checkMsg',
						align: 'center',
						width: 200,
					}, {
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.checkStatus;
							if (val == 0) {
								name = '待审核'
							} else if (val == 1) {
								name = '审核通过'
							}else if (val == 2) {
								name = '审核不通过'
							}
							return h('span', name)
						}
					}, {
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}
				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.getCompanyList(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.total || 0
						that.queryData = result.data
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			//审核
			passCheck(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '您已确认【审核通过】数据吗？',
					onOk: function() {
						api.statistics
							.checkCompany({
								checkId: id,
								checkResult: 1
							})
							.then(res => {
								const result = res.data || {}
								that.totalRecord = result.totalRecordNum || 0
								that.queryData = result.records
								that.refreshData()
							})
							.then(() => {
								that.$Message.success('Success!');
							})
					}
				})

			},
			denyCheck(id) {
				this.deneyShow=true,
				this.denyCheckData={
					checkId:id,
					checkResult:2,
					checkRemark:''
				}
			},
			denyCheckSure(){
				const that=this
				api.statistics
					.checkCompany(this.denyCheckData)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
						that.refreshData()
					})
					.then(() => {
						that.deneyShow=false
						that.$Message.success('Success!');
					})
			}
		
		},
		

	}
</script>